import { useState } from "react";
import { Badge, Button, Form, ListGroup, Modal } from "react-bootstrap";
import useCubit from "../blocs/hooks";
import { ISearchBloc, SearchBloc } from "../blocs/search/SearchBloc";
import { SearchState } from "../blocs/search/SearchState";
import SearchElementTile from "./SearchElementTile";
import SomethingWentWrong from "./core/SomethingWentWrong";
import { FirebaseVectorSearchRepository } from "../core/repositories/search/FirebaseVectorSearchRepository";
import useShortcut from "../core/utils/useShortcut";
import { LinearLoader } from "./Loader";

const searchBloc: ISearchBloc = new SearchBloc(new FirebaseVectorSearchRepository());
export default function SearchButton() {
    const state: SearchState = useCubit(searchBloc);
    const [isShown, setIsShown] = useState<boolean>(false);
    const [query, setQuery] = useState<string>("");

    function switchDialogState() {
        setIsShown(!isShown);
    }

    function search() {
        if (state.state !== "LOADING") {
            searchBloc.find(query);
        }
    }

    function submit(ev: React.FormEvent<HTMLFormElement>) {
        ev.preventDefault();
        search();
    }

    useShortcut({
        ctrlKey: true,
        key: "f",
        callBack: switchDialogState,
    });

    return <>
        <Modal show={isShown} onHide={switchDialogState}>
            <Form onSubmit={submit}>
                <Modal.Header>
                    <Form.Control type="text" autoFocus placeholder="🔎 Looking for..." onChange={(event) => { setQuery(event.target.value) }} />
                    <div style={{ padding: 4 }} />
                    <Button onClick={search} variant="outline-dark">Search</Button>
                    <div style={{ padding: 4 }} />
                    <Button onClick={switchDialogState} variant="outline-danger">Close</Button>
                </Modal.Header>
            </Form>
            <Modal.Body>
                <LinearLoader dots={state.state === "LOADING" ? 20 : 0} />
                {
                    state.state === "ERROR" && <SomethingWentWrong />
                }
                {
                    (state.state === "LOADED" || state.state === "LOADING") && <ListGroup as="ol" numbered>
                        {state.result!.map((elem, index) => (<div onClick={switchDialogState} key={`search#${index}`}>
                            <SearchElementTile target={elem} key={index} />
                        </div>))}
                    </ListGroup>
                }
            </Modal.Body>
        </Modal>
        <Button variant="outline-dark" style={{ borderRadius: 90 }} onClick={switchDialogState}>🔎 Search <Badge pill>(ctrl + f)</Badge></Button>
    </>;
}